import React, {Component} from 'react'
import styled from 'styled-components'

const StyledTab = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 8px 0 8px;
  box-sizing: border-box;
`

const StyledButton = styled.div`
  min-width: 100px;
  height: 46px;
  background-color: transparent;
  font-size: 16px;
  font-weight: 600;
  border: none;
  color: ${props => (props.active ? '#006EE5' : '#727680')};
  cursor: pointer;
  
  :focus {
	 outline: 3px solid #FF9900;
  }
`

const ResultModalCount = styled.div`
  font-size: 14px;
  font-weight: 400;

`

const Tab = (props) => {
  const onClickTab = evt => {
    if (evt) {
      evt.preventDefault()
    }

    props.onActivate()
  }
  return (
    <StyledTab>
      <StyledButton 
        id={props.id}
        role="treeitem" 
        aria-expanded={props["aria-expanded"]} 
        active={props.active} 
        tabIndex={props.tabIndex} 
        aria-owns={props["aria-owns"]} 
        data-group = "tab-group"
        onClick={onClickTab}
        onKeyDown={props.onKeyDown}
      >
        {props.title}
        <ResultModalCount role="status">
          {props.resultCount}
        </ResultModalCount>
      </StyledButton>
    </StyledTab>
  )
}

export default Tab
